(function () {
  function topChrome() {
    var h = 0;
    var nodes = document.querySelectorAll(".sticky-header, .header-section, .header-section--wrapper, header.site-header, .announcement_bar-root");
    var i;
    for (i = 0; i < nodes.length; i++) {
      var style = window.getComputedStyle(nodes[i]);
      var pos = style.position;
      if (pos === "fixed" || pos === "sticky") {
        h = Math.max(h, nodes[i].getBoundingClientRect().height);
      }
    }
    if (!h) {
      var header = document.querySelector(".header-section, header.site-header");
      if (header) h = header.getBoundingClientRect().height;
    }
    return h || 72;
  }

  function blockAround(node) {
    if (!node || !node.closest) return null;
    return node.closest(".shopify-app-block, .shopify-block, [id^='shopify-block-'], [id^='shopify-section-'], section");
  }

  function findScrollTarget() {
    var offer = document.querySelector(".lvl-offer");
    if (offer) return offer;
    var designed = document.querySelector(".lvl-order");
    if (designed) return designed;

    var file = document.querySelector('input[type="file"]');
    var fromFile = blockAround(file);
    if (fromFile) return fromFile;

    var blocks = document.querySelectorAll(".shopify-app-block, .shopify-block, [id^='shopify-block-']");
    var i;
    for (i = 0; i < blocks.length; i++) {
      var label = (blocks[i].id || "") + " " + (blocks[i].getAttribute("data-block-handle") || "");
      if (/pre_configured|artwork/i.test(label)) return blocks[i];
    }
    if (blocks.length === 1) return blocks[0];
    return null;
  }

  function scrollToTarget(target, event, center) {
    if (!target) return;
    if (event) event.preventDefault();
    var rect = target.getBoundingClientRect();
    var chrome = topChrome();
    var gap = 24;
    var room = window.innerHeight - chrome - gap * 2;
    var y = rect.top + window.pageYOffset;
    if (center && rect.height <= room) {
      y = y - chrome - gap - (room - rect.height) / 2;
    } else {
      y = y - chrome - gap;
    }
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? "auto" : "smooth" });
  }

  function scrollToOffer(event) {
    scrollToTarget(findScrollTarget(), event, true);
  }

  function scrollToHash(hash, event) {
    if (!hash || hash.charAt(0) !== "#") return false;
    if (hash === "#lvl-order") {
      scrollToOffer(event);
      return true;
    }
    if (!/^#lvl-/.test(hash)) return false;
    var target = document.getElementById(hash.slice(1));
    if (!target) return false;
    scrollToTarget(target, event, false);
    return true;
  }

  function isOrderCta(link) {
    if (!link) return false;
    if (link.hash === "#lvl-order") return true;
    if (link.hash !== "#hdmp-why") return false;
    return !!(link.closest && link.closest(".lvl-hero, .lvl-close"));
  }

  if (!window.__lvlOrderScroll) {
    window.__lvlOrderScroll = true;
    document.addEventListener("click", function (event) {
      var link = event.target.closest ? event.target.closest("a") : null;
      if (!link || !link.hash) return;
      if (link.pathname && link.pathname !== window.location.pathname) return;
      if (isOrderCta(link)) {
        scrollToOffer(event);
        return;
      }
      scrollToHash(link.hash, event);
    });
    if (window.location.hash === "#lvl-order") {
      window.setTimeout(function () { scrollToOffer(); }, 120);
    } else if (/^#lvl-/.test(window.location.hash || "")) {
      window.setTimeout(function () { scrollToHash(window.location.hash); }, 120);
    } else if (window.location.hash === "#hdmp-why") {
      window.setTimeout(function () {
        var why = document.getElementById("hdmp-why");
        if (why) scrollToTarget(why, null, false);
      }, 120);
    }
  }

  var section = document.querySelector(".lvl-order");
  if (!section) return;
  var offer = section.querySelector(".lvl-offer");
  if (!offer) return;
  var app = section.querySelector(".lvl-order__app");

  function textOf(el) {
    return ((el.innerText || el.value || "") + "").replace(/\s+/g, " ").trim();
  }

  function findFile() {
    return app ? app.querySelector('input[type="file"]') : null;
  }

  function findAtc() {
    if (!app) return null;
    var nodes = app.querySelectorAll("button, input[type='submit'], a");
    var i;
    for (i = 0; i < nodes.length; i++) {
      if (nodes[i].name === "add") return nodes[i];
      if (/add to cart|start my order/i.test(textOf(nodes[i]))) return nodes[i];
    }
    return app.querySelector("button[type='submit'], input[type='submit']");
  }

  function showPreview(file) {
    if (!file || !/^image\//.test(file.type || "")) return;
    var img = offer.querySelector("[data-offer-preview]");
    var stage = offer.querySelector("[data-offer-stage]");
    if (!img || !stage) return;
    if (img.dataset.url) URL.revokeObjectURL(img.dataset.url);
    var url = URL.createObjectURL(file);
    img.dataset.url = url;
    img.src = url;
    img.alt = file.name || "Your photo";
    stage.classList.add("has-photo");
  }

  function bindInput(input) {
    if (!input || input.dataset.lvlBound) return;
    input.dataset.lvlBound = "1";
    input.addEventListener("change", function () {
      if (input.files && input.files[0]) showPreview(input.files[0]);
    });
  }

  function arm() {
    var input = findFile();
    var atc = findAtc();
    if (!input || !atc) return false;
    bindInput(input);
    section.classList.add("is-ready");
    return true;
  }

  offer.querySelector("[data-offer-pick]").addEventListener("click", function () {
    var input = findFile();
    if (input) input.click();
  });

  var stage = offer.querySelector("[data-offer-stage]");
  stage.addEventListener("dragover", function (event) {
    event.preventDefault();
    stage.classList.add("is-drag");
  });
  stage.addEventListener("dragleave", function () {
    stage.classList.remove("is-drag");
  });
  stage.addEventListener("drop", function (event) {
    event.preventDefault();
    stage.classList.remove("is-drag");
    var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    var input = findFile();
    if (!file || !input || typeof DataTransfer === "undefined") return;
    var transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
    input.dispatchEvent(new Event("change", { bubbles: true }));
    showPreview(file);
  });

  offer.querySelector("[data-offer-atc]").addEventListener("click", function () {
    var atc = findAtc();
    if (atc) atc.click();
  });

  var sizeLine = offer.querySelector("[data-size-line]");
  var cropLine = offer.querySelector("[data-crop-line]");
  var frame = offer.querySelector("[data-offer-frame]");
  var mockImg = offer.querySelector("[data-offer-mock]");
  var sizeMatch = ((sizeLine && sizeLine.textContent) || "").match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
  var landscapeA = sizeMatch ? sizeMatch[1] : "20";
  var landscapeB = sizeMatch ? sizeMatch[2] : "30";

  var shortSide = Math.min(Number(landscapeA), Number(landscapeB));
  var longSide = Math.max(Number(landscapeA), Number(landscapeB));

  function parseBox(raw) {
    if (!raw) return null;
    var parts = raw.split(",").map(function (n) { return Number(String(n).trim()); });
    if (parts.length !== 4 || parts.some(function (n) { return !isFinite(n); })) return null;
    return { left: parts[0], top: parts[1], width: parts[2], height: parts[3] };
  }

  function paintMock(word) {
    if (!frame || !frame.classList.contains("is-mock")) return;
    var wide = word === "landscape";
    var src = wide ? frame.getAttribute("data-mock-land") : frame.getAttribute("data-mock-port");
    var box = parseBox(wide ? frame.getAttribute("data-mock-land-box") : frame.getAttribute("data-mock-port-box"));
    if (mockImg && src) mockImg.src = src;
    if (!box) return;
    frame.style.setProperty("--mock-left", (box.left * 100) + "%");
    frame.style.setProperty("--mock-top", (box.top * 100) + "%");
    frame.style.setProperty("--mock-width", (box.width * 100) + "%");
    frame.style.setProperty("--mock-height", (box.height * 100) + "%");
  }

  function paintSize(word) {
    var wide = word === "landscape";
    var a = wide ? longSide : shortSide;
    var b = wide ? shortSide : longSide;
    var dims = a + " × " + b;
    if (sizeLine) sizeLine.textContent = dims + " inches · " + word;
    if (cropLine) {
      cropLine.textContent = cropLine.textContent.replace(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/, dims);
    }
    if (frame) frame.style.setProperty("--lvl-ratio", a + " / " + b);
    paintMock(word);
  }

  function triggerAppOrient(name) {
    if (!app) return;
    var nodes = app.querySelectorAll("button, [role='button'], label, input, select, [data-orient], [data-orientation]");
    var i;
    var pattern = new RegExp("\\b" + name + "\\b", "i");
    for (i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var blob = [
        textOf(el),
        el.value || "",
        el.getAttribute("data-orient") || "",
        el.getAttribute("data-orientation") || "",
        el.getAttribute("aria-label") || ""
      ].join(" ");
      if (!pattern.test(blob)) continue;
      if (el.tagName === "INPUT") {
        el.checked = true;
        el.dispatchEvent(new Event("input", { bubbles: true }));
        el.dispatchEvent(new Event("change", { bubbles: true }));
      }
      if (el.tagName === "SELECT") {
        el.value = name;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      }
      el.click();
      return;
    }
  }

  paintSize("landscape");

  offer.querySelectorAll("[data-orient]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var name = btn.getAttribute("data-orient");
      offer.querySelectorAll("[data-orient]").forEach(function (other) {
        other.classList.remove("is-on");
        other.setAttribute("aria-pressed", "false");
      });
      btn.classList.add("is-on");
      btn.setAttribute("aria-pressed", "true");
      paintSize(name);
      triggerAppOrient(name);
    });
  });

  arm();
  if (app && window.MutationObserver) {
    new MutationObserver(function () {
      arm();
    }).observe(app, { childList: true, subtree: true });
  }
})();
